export function initCursor() {
  // No ejecutar en mobile
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
    return;
  }

  // Crear elementos
  const dot = document.createElement("div");
  const circle = document.createElement("div");

  dot.className = "cursor-dot";
  circle.className = "cursor-circle";

  document.body.appendChild(dot);
  document.body.appendChild(circle);

  let mouseX = 0,
    mouseY = 0;
  let circleX = 0,
    circleY = 0;

  document.addEventListener("mousemove", (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    dot.style.left = mouseX + "px";
    dot.style.top = mouseY + "px";
  });

  function animate() {
    circleX += (mouseX - circleX) * 0.08;
    circleY += (mouseY - circleY) * 0.08;
    circle.style.left = circleX + "px";
    circle.style.top = circleY + "px";
    requestAnimationFrame(animate);
  }

  animate();
}
